import { DateOnly } from '../utility';

export interface ISpecialPackageReservationDto {
  specialPackageRoomCategoryId: number | null;
  occupancy: number | null;

  contactBirthday: DateOnly | null;
  contactLanguage: string | null;
  contactMail: string;
  contactPhone: string | null;
  contactTitle: string | null;
  contactFirstname: string;
  contactLastname: string;

  contactStreet: string;
  contactStreetNr: string;
  contactPostal: string;
  contactCity: string;
  contactCountry: string;

  agbAccepted: boolean;
  privacyPolicyAccepted: boolean;
  newsletter: boolean;

  message: string | null;
}

export const EmptySpecialPackageReservationDto: ISpecialPackageReservationDto =
  {
    specialPackageRoomCategoryId: null,
    occupancy: null,

    contactBirthday: null,
    contactLanguage: null,
    contactMail: '',
    contactPhone: null,
    contactTitle: null,
    contactFirstname: '',
    contactLastname: '',

    contactStreet: '',
    contactStreetNr: '',
    contactPostal: '',
    contactCity: '',
    contactCountry: '',

    agbAccepted: false,
    privacyPolicyAccepted: false,
    newsletter: false,

    message: null,
  };
